import React from "react";
import clientConfigApi from '../config/config'

export const get7roomsRestaurantReservationData = async () => {

    let payload = {
        "header": {
            "sessionToken": localStorage.getItem("GuestJourneySessionToken")
        },
        "payload": {
        }
    }

    try {
        let data = await clientConfigApi.post(`/restaurantTableBooking/getAllVenues`, payload)
        return data
    } catch (error) {
        return error
    }

}


export const searchVenueAvailability = async (payload) => {

    let requestPayload = {
        "header": {
            "sessionToken": localStorage.getItem("GuestJourneySessionToken")
        },
        "payload": payload
    }

    try {
        let data = await clientConfigApi.post(`/restaurantTableBooking/getVenueAvailability`,requestPayload)

        return data
    } catch (error) {
        return error
    }
}


export const searchDailyProgrammeData = async (payload) => {

    const currentUserInfo = JSON.parse(localStorage.getItem("Set_Current_Logged_In_Guest_Details"))

    let requestPayload = {
        "header": {
            "sessionToken": localStorage.getItem("GuestJourneySessionToken"),
            "reservationNumber": currentUserInfo && currentUserInfo[0].reservationNumber,
            "guestToken": currentUserInfo && currentUserInfo[0].guestToken,
        },
        "payload": payload
    }

    try {
        let data = await clientConfigApi.post(`/restaurantTableBooking/getAllPrograms`,requestPayload)

        return data
    } catch (error) {
        return error
    }
}



export const getMyReservationData = async (clientId) => {

    const currentUserInfo = JSON.parse(localStorage.getItem("Set_Current_Logged_In_Guest_Details"))

    let requestPayload = {
        "header": {
            "sessionToken": localStorage.getItem("GuestJourneySessionToken"),
            "reservationNumber": currentUserInfo && currentUserInfo[0].reservationNumber,
            "guestToken": currentUserInfo && currentUserInfo[0].guestToken,
        },
        "payload": {
            "clientId": clientId
        }
    }

    if(!clientId || clientId == ""){

        return {
            status: 200,
            data: {
                payload: {
                    data: {
                        results: []
                    }
                }
            }
        }
    }

    try {
        let data = await clientConfigApi.post(`/restaurantTableBooking/getAllReservations`,requestPayload)

        return data
    } catch (error) {
        return error
    }
}


export const createRestaurantReservationV2 = async (payload) => {

    const currentUserInfo = JSON.parse(localStorage.getItem("Set_Current_Logged_In_Guest_Details"))

    const requestPayload = {
        "header": {
            "sessionToken": localStorage.getItem("GuestJourneySessionToken"),
            "reservationNumber":  currentUserInfo && currentUserInfo[0].reservationNumber,
            "guestToken":  currentUserInfo && currentUserInfo[0].guestToken,
        },
        "payload": payload
    }

    try {
        let data = await clientConfigApi.post(`/restaurantTableBooking/createReservation`, requestPayload)

        return data
    } catch (error) {
        return error
    }
}


export const updateRestaurantReservationV2 = async (payload) => {

    const currentUserInfo = JSON.parse(localStorage.getItem("Set_Current_Logged_In_Guest_Details"))

    const requestPayload = {
        "header": {
            "sessionToken": localStorage.getItem("GuestJourneySessionToken"),
            "reservationNumber":  currentUserInfo && currentUserInfo[0].reservationNumber,
            "guestToken":  currentUserInfo && currentUserInfo[0].guestToken,
        },
        "payload": payload
    }

    try {
        let data = await clientConfigApi.post(`/restaurantTableBooking/updateReservation`, requestPayload)

        return data
    } catch (error) {
        return error
    }
}



export const cancelRestaurantReservationV2 = async (payload) => {

    const currentUserInfo = JSON.parse(localStorage.getItem("Set_Current_Logged_In_Guest_Details"))

    const requestPayload = {
        "header": {
            "sessionToken": localStorage.getItem("GuestJourneySessionToken"),
            "reservationNumber":  currentUserInfo && currentUserInfo[0].reservationNumber,
            "guestToken":  currentUserInfo && currentUserInfo[0].guestToken,
        },
        "payload": payload
    }

    try {
        let data = await clientConfigApi.post(`/restaurantTableBooking/cancelReservation`,requestPayload)

        return data
    } catch (error) {
        return error
    }
}